import * as actionTypes from './actionTypes';

export const fetchDocumentsByActiveFolder = (spaceId, folderId) => ({
  type: actionTypes.FETCH_BY_ACTIVE_FOLDER,
  spaceId,
  folderId,
});
export const fetchDocumentsByActiveFolderSuccess = ids => ({
  type: actionTypes.FETCH_BY_ACTIVE_FOLDER_SUCCESS,
  ids,
});

export const fetchDocumentsRecursiveByFolderPath = (spaceId, folderPath) => ({
  type: actionTypes.FETCH_RECURSIVE_BY_FOLDER_PATH,
  spaceId,
  folderPath,
});
export const fetchDocumentsRecursiveByFolderPathSuccess = ids => ({
  type: actionTypes.FETCH_RECURSIVE_BY_FOLDER_PATH_SUCCESS,
  ids,
});

export const fetchDocument = id => ({
  type: actionTypes.FETCH,
  id,
});
export const fetchDocumentSuccess = id => ({
  type: actionTypes.FETCH_SUCCESS,
  id,
});
export const fetchDocumentError = id => ({
  type: actionTypes.FETCH_ERROR,
  id,
});

export const uploadDocuments = (filesFormData, space, folder) => ({
  type: actionTypes.UPLOAD,
  filesFormData,
  space,
  folder,
});
export const uploadDocumentsSuccess = ids => ({
  type: actionTypes.UPLOAD_SUCCESS,
  ids,
});

export const downloadDocument = document => ({
  type: actionTypes.DOWNLOAD,
  document,
});
export const downloadDocumentSuccess = (blob, document) => ({
  type: actionTypes.DOWNLOAD_SUCCESS,
  blob,
  document,
});

export const downloadMultipleDocumentsAndFolders = (documents, folders, title = 'files') => ({
  type: actionTypes.DOWNLOAD_MULTIPLE,
  documents,
  folders,
  title,
});
export const downloadMultipleDocumentsAndFoldersSuccess = (blob, documents, folders) => ({
  type: actionTypes.DOWNLOAD_MULTIPLE_SUCCESS,
  blob,
  documents,
  folders,
});

export const updateDocument = (document, newFile, password = null) => ({
  type: actionTypes.UPDATE,
  document,
  newFile,
  password,
});
export const updateDocumentPasswordMismatch = () => ({
  type: actionTypes.UPDATE_PASSWORD_MISMATCH,
});
export const updateDocumentSuccess = (document, activeFolderId) => ({
  type: actionTypes.UPDATE_SUCCESS,
  document,
  activeFolderId,
});

export const cloneDocument = id => ({
  type: actionTypes.CLONE,
  id,
});
export const cloneDocumentSuccess = id => ({
  type: actionTypes.CLONE_SUCCESS,
  id,
});

export const deleteDocument = document => ({
  type: actionTypes.DELETE,
  document,
});
export const deleteDocumentSuccess = document => ({
  type: actionTypes.DELETE_SUCCESS,
  document,
});

export const setActiveDocumentId = id => ({
  type: actionTypes.SET_ACTIVE_DOCUMENT_ID,
  id,
});

export const setUploadPercentage = percent => ({
  type: actionTypes.SET_UPLOAD_PERCENTAGE,
  percent,
});

export const shareDocuments = (
  documentIds,
  folderIds,
  userIds,
  roleIds,
  mailingListIds,
  ccUserIds,
  subject,
  message,
) => ({
  type: actionTypes.SHARE,
  documentIds,
  folderIds,
  userIds,
  roleIds,
  mailingListIds,
  ccUserIds,
  subject,
  message,
});
export const shareDocumentsSuccess = () => ({
  type: actionTypes.SHARE_SUCCESS,
});

export const navigateToDocument = document => ({
  type: actionTypes.NAVIGATE_TO_DOCUMENT,
  document,
});
